var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('navbar',{staticClass:"sticky top-0 z-20"}),_c('div',{staticClass:"grid grid-cols-12"},[_c('div',{staticClass:"col-start-3 col-end-11"},[_c('transition',{attrs:{"name":"fade"}},[_c('router-view')],1)],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }